import { versionInfo as version } from "../version"
import { SlashID } from "../main/index"
import { BrowserUser as User } from "../main/user.browser"
import * as errors from "../domain/errors"
import * as errors_INTERNAL_ONLY from "../domain/errors.internal"
import * as utils from "../utils/passkeys"
;(window as any).slashid = {
    SlashID,
    User,
    version,
    errors: {
        ...errors,
        // TODO: remove this export
        ...errors_INTERNAL_ONLY,
    },
    utils,
}
